import { palette } from '@awarego/awarego-components';

export const awareGoTheme = {
    primary: palette.evergreen.aspargus,
    secondary: palette.vibrant.raspberry,
};
